function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M585.676 300C585.676 462.998 455.614 595 295.338 595C135.062 595 5 462.998 5 300C5 137.002 135.062 5 295.338 5C455.614 5 585.676 137.002 585.676 300Z",
  fill: "white",
  stroke: "#D9C4FC",
  strokeWidth: 10
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M397.933 98.0843L425.845 38.3142C550.77 94.0997 595.579 237.165 586.15 321.456L549.185 341.379V380.843L529.949 457.854L461.301 534.866L437.161 507.663V457.854L368.512 395.785L437.161 341.379L500.528 272.031L507.695 237.165L417.547 272.031L339.469 237.165V180.077L317.215 110.728L397.933 98.0843Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC",
  strokeWidth: 5
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M69.4026 330.268L88.2619 350.191L107.876 360.153L88.2619 375.862L113.534 422.988L100.332 445.211L139.937 488.889V542.529L187.085 502.299L224.427 496.552L218.015 453.257L233.479 411.877L212.357 375.862L179.541 388.122L139.937 360.153L134.279 312.26L187.085 270.881L255.356 220.69L203.681 196.935L212.357 135.632L161.814 116.475L134.279 93.1034L100.332 86.59L88.2619 116.475L53.9379 135.632C41.5661 141.762 18.8594 205.364 9.05252 236.398L37.3416 291.954L69.4026 330.268Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M253.093 564.751L213.488 581.609C284.701 612.873 385.989 583.397 420.564 564.751H409.626C383.097 560.281 328.757 551.341 323.627 551.341C318.497 551.341 303.888 564.878 297.224 571.647L253.093 564.751Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M203.681 42.9119L172.752 36.0154C218.316 -1.68577 303.385 1.14948 340.223 7.27974L319.101 17.2414L297.224 42.9119L273.084 76.2453L249.698 66.2836H213.488L203.681 42.9119Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M249.508 43.6224C256.902 52.6928 270.134 53.9572 279.064 46.4465C287.993 38.9358 289.238 25.494 281.844 16.4236C274.45 7.35308 261.217 6.08866 252.288 13.5994C243.358 21.1101 242.114 34.5519 249.508 43.6224Z",
  fill: "white",
  stroke: "#D9C4FC",
  strokeWidth: 5
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M258.168 40.1729C260.926 43.7012 269.277 45.6421 274.054 38.8555",
  stroke: "#D9C4FC",
  strokeWidth: 2
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M260.492 26.0617C260.492 27.6248 259.247 28.8786 257.727 28.8786C256.207 28.8786 254.962 27.6248 254.962 26.0617C254.962 24.4985 256.207 23.2448 257.727 23.2448C259.247 23.2448 260.492 24.4985 260.492 26.0617Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M276.67 26.0617C276.67 27.6248 275.424 28.8786 273.905 28.8786C272.385 28.8786 271.139 27.6248 271.139 26.0617C271.139 24.4985 272.385 23.2448 273.905 23.2448C275.424 23.2448 276.67 24.4985 276.67 26.0617Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M356.629 171.592C364.023 180.662 377.256 181.926 386.185 174.416C395.115 166.905 396.36 153.463 388.966 144.393C381.572 135.322 368.339 134.058 359.409 141.569C350.48 149.079 349.235 162.521 356.629 171.592Z",
  fill: "white",
  stroke: "#D9C4FC",
  strokeWidth: 5
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M365.29 168.142C368.047 171.67 376.399 173.611 381.175 166.825",
  stroke: "#D9C4FC",
  strokeWidth: 2
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M367.614 154.031C367.614 155.594 366.368 156.848 364.848 156.848C363.328 156.848 362.083 155.594 362.083 154.031C362.083 152.468 363.328 151.214 364.848 151.214C366.368 151.214 367.614 152.468 367.614 154.031Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M383.791 154.031C383.791 155.594 382.546 156.848 381.026 156.848C379.506 156.848 378.26 155.594 378.26 154.031C378.26 152.468 379.506 151.214 381.026 151.214C382.546 151.214 383.791 152.468 383.791 154.031Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M145.404 238.259C152.798 247.329 166.031 248.593 174.96 241.083C183.89 233.572 185.134 220.13 177.74 211.06C170.346 201.989 157.114 200.725 148.184 208.236C139.255 215.746 138.01 229.188 145.404 238.259Z",
  fill: "white",
  stroke: "#D9C4FC",
  strokeWidth: 5
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M154.065 234.809C156.822 238.337 165.173 240.278 169.95 233.492",
  stroke: "#D9C4FC",
  strokeWidth: 2
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M156.389 220.698C156.389 222.261 155.143 223.515 153.623 223.515C152.103 223.515 150.858 222.261 150.858 220.698C150.858 219.135 152.103 217.881 153.623 217.881C155.143 217.881 156.389 219.135 156.389 220.698Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M172.566 220.698C172.566 222.261 171.321 223.515 169.801 223.515C168.281 223.515 167.035 222.261 167.035 220.698C167.035 219.135 168.281 217.881 169.801 217.881C171.321 217.881 172.566 219.135 172.566 220.698Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M436.593 358.565C443.987 367.635 457.22 368.9 466.149 361.389C475.079 353.878 476.323 340.437 468.929 331.366C461.535 322.296 448.302 321.031 439.373 328.542C430.443 336.053 429.199 349.494 436.593 358.565Z",
  fill: "white",
  stroke: "#D9C4FC",
  strokeWidth: 5
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M445.254 355.116C448.011 358.644 456.362 360.585 461.139 353.798",
  stroke: "#D9C4FC",
  strokeWidth: 2
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M447.578 341.004C447.578 342.568 446.332 343.821 444.812 343.821C443.292 343.821 442.047 342.568 442.047 341.004C442.047 339.441 443.292 338.188 444.812 338.188C446.332 338.188 447.578 339.441 447.578 341.004Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M463.755 341.004C463.755 342.568 462.51 343.821 460.99 343.821C459.47 343.821 458.224 342.568 458.224 341.004C458.224 339.441 459.47 338.188 460.99 338.188C462.51 338.188 463.755 339.441 463.755 341.004Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M332.489 565.461C339.883 574.532 353.116 575.796 362.045 568.286C370.975 560.775 372.22 547.333 364.826 538.263C357.431 529.192 344.199 527.928 335.269 535.439C326.34 542.949 325.095 556.391 332.489 565.461Z",
  fill: "white",
  stroke: "#D9C4FC",
  strokeWidth: 5
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M341.15 562.012C343.907 565.541 352.259 567.481 357.035 560.695",
  stroke: "#D9C4FC",
  strokeWidth: 2
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M343.474 547.901C343.474 549.464 342.228 550.718 340.708 550.718C339.188 550.718 337.943 549.464 337.943 547.901C337.943 546.338 339.188 545.084 340.708 545.084C342.228 545.084 343.474 546.338 343.474 547.901Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M359.651 547.901C359.651 549.464 358.406 550.718 356.886 550.718C355.366 550.718 354.12 549.464 354.12 547.901C354.12 546.338 355.366 545.084 356.886 545.084C358.406 545.084 359.651 546.338 359.651 547.901Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M495.434 119.484C502.828 128.555 516.061 129.819 524.99 122.309C533.92 114.798 535.165 101.356 527.771 92.2856C520.377 83.2151 507.144 81.9507 498.214 89.4615C489.285 96.9722 488.04 110.414 495.434 119.484Z",
  fill: "white",
  stroke: "#D9C4FC",
  strokeWidth: 5
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M504.095 116.035C506.852 119.563 515.204 121.504 519.98 114.718",
  stroke: "#D9C4FC",
  strokeWidth: 2
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M506.419 101.924C506.419 103.487 505.173 104.741 503.653 104.741C502.133 104.741 500.888 103.487 500.888 101.924C500.888 100.361 502.133 99.1068 503.653 99.1068C505.173 99.1068 506.419 100.361 506.419 101.924Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M522.596 101.924C522.596 103.487 521.351 104.741 519.831 104.741C518.311 104.741 517.066 103.487 517.066 101.924C517.066 100.361 518.311 99.1068 519.831 99.1068C521.351 99.1068 522.596 100.361 522.596 101.924Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M554.275 261.247C561.669 270.317 574.902 271.582 583.832 264.071C592.761 256.56 594.006 243.119 586.612 234.048C579.218 224.978 565.985 223.713 557.055 231.224C548.126 238.735 546.881 252.176 554.275 261.247Z",
  fill: "white",
  stroke: "#D9C4FC",
  strokeWidth: 5
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M562.936 257.797C565.694 261.326 574.045 263.267 578.821 256.48",
  stroke: "#D9C4FC",
  strokeWidth: 2
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M565.26 243.686C565.26 245.249 564.015 246.503 562.495 246.503C560.975 246.503 559.729 245.249 559.729 243.686C559.729 242.123 560.975 240.869 562.495 240.869C564.015 240.869 565.26 242.123 565.26 243.686Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M581.438 243.686C581.438 245.249 580.192 246.503 578.672 246.503C577.152 246.503 575.907 245.249 575.907 243.686C575.907 242.123 577.152 240.869 578.672 240.869C580.192 240.869 581.438 242.123 581.438 243.686Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M156.719 412.205C164.113 421.275 177.346 422.54 186.276 415.029C195.205 407.518 196.45 394.077 189.056 385.006C181.662 375.936 168.429 374.671 159.5 382.182C150.57 389.693 149.325 403.134 156.719 412.205Z",
  fill: "white",
  stroke: "#D9C4FC",
  strokeWidth: 5
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M165.38 408.755C168.138 412.284 176.489 414.225 181.266 407.438",
  stroke: "#D9C4FC",
  strokeWidth: 2
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M167.704 394.644C167.704 396.207 166.459 397.461 164.939 397.461C163.419 397.461 162.173 396.207 162.173 394.644C162.173 393.081 163.419 391.827 164.939 391.827C166.459 391.827 167.704 393.081 167.704 394.644Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M183.882 394.644C183.882 396.207 182.636 397.461 181.116 397.461C179.596 397.461 178.351 396.207 178.351 394.644C178.351 393.081 179.596 391.827 181.116 391.827C182.636 391.827 183.882 393.081 183.882 394.644Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M122.773 505.691C130.167 514.762 143.399 516.026 152.329 508.515C161.258 501.005 162.503 487.563 155.109 478.492C147.715 469.422 134.482 468.158 125.553 475.668C116.623 483.179 115.378 496.621 122.773 505.691Z",
  fill: "white",
  stroke: "#D9C4FC",
  strokeWidth: 5
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M131.433 502.242C134.191 505.77 142.542 507.711 147.319 500.925",
  stroke: "#D9C4FC",
  strokeWidth: 2
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  d: "M133.757 488.13C133.757 489.694 132.512 490.947 130.992 490.947C129.472 490.947 128.227 489.694 128.227 488.13C128.227 486.567 129.472 485.313 130.992 485.313C132.512 485.313 133.757 486.567 133.757 488.13Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  d: "M149.935 488.13C149.935 489.694 148.689 490.947 147.17 490.947C145.65 490.947 144.404 489.694 144.404 488.13C144.404 486.567 145.65 485.313 147.17 485.313C148.689 485.313 149.935 486.567 149.935 488.13Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  d: "M487.89 468.91C495.284 477.98 508.517 479.245 517.447 471.734C526.376 464.223 527.621 450.782 520.227 441.711C512.833 432.641 499.6 431.376 490.67 438.887C481.741 446.398 480.496 459.839 487.89 468.91Z",
  fill: "white",
  stroke: "#D9C4FC",
  strokeWidth: 5
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  d: "M496.551 465.46C499.309 468.989 507.66 470.93 512.436 464.143",
  stroke: "#D9C4FC",
  strokeWidth: 2
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  d: "M498.875 451.349C498.875 452.912 497.63 454.166 496.11 454.166C494.59 454.166 493.344 452.912 493.344 451.349C493.344 449.786 494.59 448.532 496.11 448.532C497.63 448.532 498.875 449.786 498.875 451.349Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  d: "M515.053 451.349C515.053 452.912 513.807 454.166 512.287 454.166C510.767 454.166 509.522 452.912 509.522 451.349C509.522 449.786 510.767 448.532 512.287 448.532C513.807 448.532 515.053 449.786 515.053 451.349Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.4406 171.592C29.8346 180.662 43.0674 181.927 51.997 174.416C60.9265 166.905 62.1712 153.463 54.7772 144.393C47.3832 135.322 34.1504 134.058 25.2208 141.569C16.2913 149.079 15.0465 162.521 22.4406 171.592Z",
  fill: "white",
  stroke: "#D9C4FC",
  strokeWidth: 5
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  d: "M31.1015 168.142C33.859 171.671 42.2102 173.612 46.9867 166.825",
  stroke: "#D9C4FC",
  strokeWidth: 2
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.4254 154.031C33.4254 155.594 32.1799 156.848 30.66 156.848C29.1401 156.848 27.8946 155.594 27.8946 154.031C27.8946 152.468 29.1401 151.214 30.66 151.214C32.1799 151.214 33.4254 152.468 33.4254 154.031Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  d: "M49.6029 154.031C49.6029 155.594 48.3575 156.848 46.8375 156.848C45.3176 156.848 44.0721 155.594 44.0721 154.031C44.0721 152.468 45.3176 151.214 46.8375 151.214C48.3575 151.214 49.6029 152.468 49.6029 154.031Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.5456 304.925C47.9396 313.995 61.1724 315.26 70.102 307.749C79.0315 300.238 80.2763 286.797 72.8822 277.726C65.4882 268.656 52.2554 267.391 43.3258 274.902C34.3963 282.413 33.1516 295.854 40.5456 304.925Z",
  fill: "white",
  stroke: "#D9C4FC",
  strokeWidth: 5
});

var _ref52 =
/*#__PURE__*/
React.createElement("path", {
  d: "M49.2065 301.476C51.9639 305.004 60.3152 306.945 65.0917 300.158",
  stroke: "#D9C4FC",
  strokeWidth: 2
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  d: "M51.5304 287.365C51.5304 288.928 50.285 290.181 48.7651 290.181C47.2451 290.181 45.9997 288.928 45.9997 287.365C45.9997 285.801 47.2451 284.548 48.7651 284.548C50.285 284.548 51.5304 285.801 51.5304 287.365Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var _ref54 =
/*#__PURE__*/
React.createElement("path", {
  d: "M67.708 287.365C67.708 288.928 66.4625 290.181 64.9426 290.181C63.4226 290.181 62.1772 288.928 62.1772 287.365C62.1772 285.801 63.4226 284.548 64.9426 284.548C66.4625 284.548 67.708 285.801 67.708 287.365Z",
  fill: "#D9C4FC",
  stroke: "#D9C4FC"
});

var SvgBgEarth = function SvgBgEarth(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBgEarth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bgEarth.23805b90.svg";
export { ForwardRef as ReactComponent };